import { ReactNode } from "react";
import useCheckPermission from "@/Hooks/useCheckPermission";
import NotFound from "@/Pages/NotFound";

const PartnerProtectedRoute = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  const { hasPermission, authService } = useCheckPermission();

  if (authService.isLoading) return null;

  if (!hasPermission.view) {
    return <NotFound />;
  }

  return children;
};

export default PartnerProtectedRoute;
